import {Task} from "@megaphonenpm/mputils/src/Task.js";
import {warn} from '@megaphonenpm/mputils/src/logfunctions.js';
import {replaceAll} from '@megaphonenpm/mputils/src/utils.js';
import {LoadJSONTask} from '@megaphonenpm/mputils/src/LoadJSONTask.js';
import {COMPLETE, FAIL} from '@megaphonenpm/mputils/src/constants.js';
import {SCENE_TYPE_PREDICTION, SCENE_TYPE_SURVEY} from './constants.js';

/**
 * Retrieves the specified web poll from Web Poll Service.
 */
export class GetWebPollTask extends Task {
  constructor (sourceID, dataStore, sceneType = SCENE_TYPE_SURVEY) {
    super();
    this.name = "GET_WEB_POLL";
    this.sourceID = sourceID;
    this.dataStore = dataStore;
    this.sceneType = sceneType;
  }

  start () {
    super.start();

    let getWebPollURL = replaceAll(GetWebPollTask.SERVICE_URLS.get(this.sceneType),
      {
        '$subdomain': GetWebPollTask.SERVICE_SUBDOMAINS.get(this.sceneType).get(this.dataStore.environment),
        '$projectid': this.dataStore.deploymentID,
        '$sourceid': this.sourceID
      });

    let loadJSONTask = new LoadJSONTask(getWebPollURL,
      {
        headersObj:
          {
            'Authorization':
              `Key`
          }
      });
    loadJSONTask.on(COMPLETE, () => {
      this.onWebPollLoadSuccess(loadJSONTask.json);
      this.done();
    });
    loadJSONTask.on(FAIL, (e) => {
      // Data failed to load
      let error = e.detail.error;
      let contentName = null;

      warn(`Failed to load ${contentName}. Either the Internet connection is unavailable `
        + `or an error occurred while retrieving data for content: [${this.sourceID}]`);
      this.fail(`Failed to load ${contentName}.`);
    });
    loadJSONTask.start();
  }

  onWebPollLoadSuccess (loadedPollRecord) {
    // To be implemented by subclasses
  }
}

GetWebPollTask.SERVICE_URLS = new Map([
  [SCENE_TYPE_SURVEY, 'https://$subdomain.execute-api.us-east-1.amazonaws.com/Prod/api/v2/projects/$projectid/polls/$sourceid/legacy'],
  [SCENE_TYPE_PREDICTION, 'https://$subdomain.execute-api.us-east-1.amazonaws.com/Prod/api/v1/projects/$projectid/scenes/$sourceid/']]);

GetWebPollTask.SERVICE_SUBDOMAINS = new Map();
GetWebPollTask.SERVICE_SUBDOMAINS.set(SCENE_TYPE_SURVEY, new Map(
  [
    ['live', 's0bcxkbrx1'],
    ['dev', 'vnf80hu8u9']]
));
GetWebPollTask.SERVICE_SUBDOMAINS.set(SCENE_TYPE_PREDICTION, new Map(
  [
    ['live', '977pjg3p18'],
    ['dev', 'thvjkjw959']]
));

